import Image from "next/image";
import Link from "next/link";

const WP = "https://www.aestradadixital.gal/wp-content/uploads";
const LEGAL_LINKS = [
  { href: "/politica-de-cookies", label: "Política de cookies", external: false },
  { href: `${WP}/2025/01/proteccion_datos.pdf`, label: "Política de privacidade", external: true },
  { href: `${WP}/2025/07/condicionsxerais_ga.pdf`, label: "Condicións xerais", external: true },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t-4 border-[var(--blue)]">
      <div className="bg-gradient-to-b from-[#0c244a] to-[#061528]">
        <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-12 md:flex-row md:items-center md:justify-between">
          {/* Marca + contacto */}
          <div className="flex flex-col items-center gap-4 text-center md:flex-row md:items-center md:gap-6 md:text-left">
            <Image
              src="/logo-trans.webp"
              alt="A Estrada Dixital"
              width={200}
              height={190}
              className="h-20 w-auto"
            />
            <div className="text-sm">
              <a
                href="tel:+34986570997"
                className="block font-semibold text-white transition hover:text-[var(--blue)]"
              >
                986 570 997
              </a>
              <a
                href="mailto:soporte@aestradadixital.gal"
                className="block text-gray-400 transition hover:text-[var(--blue)]"
              >
                soporte@aestradadixital.gal
              </a>
              <span className="block text-gray-500">A Estrada, Pontevedra</span>
            </div>
          </div>

          {/* Descarga da app */}
          <div className="flex flex-col items-center gap-3 md:items-end">
            <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">
              Descarga a nosa app
            </span>
            <div className="flex gap-3">
              <a
                href="https://apps.apple.com/es/app/aestradadixital/id6447520389"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Descargar na App Store"
                className="transition hover:opacity-80"
              >
                <Image
                  src="/appstore.png"
                  alt="Descargar na App Store"
                  width={610}
                  height={180}
                  className="h-11 w-auto"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.dowisp.aestrada"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Descargar en Google Play"
                className="transition hover:opacity-80"
              >
                <Image
                  src="/playstore.png"
                  alt="Descargar en Google Play"
                  width={610}
                  height={180}
                  className="h-11 w-auto"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Barra inferior */}
        <div className="border-t border-white/10">
          <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-5 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between">
            <p>
              &copy; {year} Fundación Cultural da Estrada &middot; NIF G36216406
            </p>
            <div className="flex flex-wrap gap-x-5 gap-y-1">
              {LEGAL_LINKS.map((link) =>
                link.external ? (
                  <a
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition hover:text-white"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.href}
                    href={link.href}
                    className="transition hover:text-white"
                  >
                    {link.label}
                  </Link>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
